import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function ScrollReveal({
  children,
  delay = 0,
  duration = 0.6,
  y = 30,
  opacity = true,
  className = "",
  as: Component = "div",
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const MotionComponent = motion[Component] || motion.div;

  return (
    <MotionComponent
      ref={ref}
      initial={{
        opacity: opacity ? 0 : 1,
        y,
      }}
      animate={
        isInView
          ? {
              opacity: 1,
              y: 0,
            }
          : undefined
      }
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className={className}
    >
      {children}
    </MotionComponent>
  );
}
